module.exports = __webpack_public_path__ + "img/_Compound Path_.f20c3311.png";